import React from 'react'
import { IconButton, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import ChartBlankView from 'src/Libs/chart-kit/shared/components/ChartBlankView'
import { J1LeftarrowC } from '@e3dc-react/icons'

const DetailPageSkeleton: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useCustomTranslation()
  return (
    <>
      <Stack flexDirection="row" gap={4} alignItems="center">
        <IconButton onClick={() => navigate(-1)}>
          <J1LeftarrowC sx={{ width: '30px', height: '30px', color: 'primary.main' }} />
        </IconButton>
        <Typography variant="h2">{t('ai360.details-page.title')}</Typography>
      </Stack>
      <Stack sx={{ padding: 2, height: '200px', display: 'flex', flexDirection: 'column' }}>
        <ChartBlankView />
      </Stack>
    </>
  )
}

export default DetailPageSkeleton
